function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1972(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22.83,
    height: 9.99,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.11
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.415,
    y: 4.995
  }, "\n        _Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.99,
    width: 22.83,
    height: 20.72,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.302222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.415,
    y: 20.35
  }, "\n        _Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 30.72,
    width: 22.83,
    height: 25.83,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8049999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.415,
    y: 43.635
  }, "\n        _Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 56.54,
    width: 22.83,
    height: 28.79,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8049999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.415,
    y: 70.935
  }, "\n        _Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 85.34,
    width: 22.83,
    height: 37.11,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.283
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.415,
    y: 103.89500000000001
  }, "\n        _Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 122.45,
    width: 22.83,
    height: 41.6,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.261428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.415,
    y: 143.25
  }, "\n        _Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 164.05,
    width: 22.83,
    height: 45.94,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.85375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.415,
    y: 187.02
  }, "\n        _Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 209.99,
    width: 22.83,
    height: 46.72,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.85375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.415,
    y: 233.35000000000002
  }, "\n        _Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 256.71,
    width: 22.83,
    height: 48.73,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5366666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.415,
    y: 281.075
  }, "\n        _Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 305.44,
    width: 22.83,
    height: 50.2,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8049999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.415,
    y: 330.54
  }, "\n        _Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 355.64,
    width: 22.83,
    height: 54.41,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5366666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.415,
    y: 382.84499999999997
  }, "\n        _Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 410.05,
    width: 22.83,
    height: 54.8,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5366666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.415,
    y: 437.45
  }, "\n        _Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 464.85,
    width: 22.83,
    height: 56.67,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8049999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.415,
    y: 493.185
  }, "\n        _Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 521.52,
    width: 22.83,
    height: 58.47,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5366666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.415,
    y: 550.755
  }, "\n        _Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 579.99,
    width: 22.83,
    height: 58.79,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.261428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.415,
    y: 609.385
  }, "\n        _Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 638.78,
    width: 22.83,
    height: 61.22,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5366666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.415,
    y: 669.39
  }, "\n        _Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.83,
    y: 0,
    width: 34.83,
    height: 42.95,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.166363636363636
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.245,
    y: 21.475
  }, "\n        _Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.66,
    y: 0,
    width: 35.79,
    height: 42.95,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.112857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.55499999999999,
    y: 21.475
  }, "\n        _Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.45,
    y: 0,
    width: 35.96,
    height: 42.95,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.137142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.43,
    y: 21.475
  }, "\n        _Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.41,
    y: 0,
    width: 36.61,
    height: 42.95,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.328181818181818
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 147.715,
    y: 21.475
  }, "\n        _Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.02,
    y: 0,
    width: 39.34,
    height: 42.95,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.9175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 185.69,
    y: 21.475
  }, "\n        _Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 205.36,
    y: 0,
    width: 40.34,
    height: 42.95,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.762857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.53000000000003,
    y: 21.475
  }, "\n        _Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 245.7,
    y: 0,
    width: 40.8,
    height: 42.95,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.533333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 266.09999999999997,
    y: 21.475
  }, "\n        _Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286.5,
    y: 0,
    width: 41.12,
    height: 42.95,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 307.06,
    y: 21.475
  }, "\n        _Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.62,
    y: 0,
    width: 41.69,
    height: 42.95,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7899999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 348.46500000000003,
    y: 21.475
  }, "\n        _Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 369.31,
    y: 0,
    width: 42.7,
    height: 42.95,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.3375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 390.66,
    y: 21.475
  }, "\n        _Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412.01,
    y: 0,
    width: 42.91,
    height: 42.95,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.767777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 433.465,
    y: 21.475
  }, "\n        _Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 454.92,
    y: 0,
    width: 46.99,
    height: 42.95,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.135714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 478.415,
    y: 21.475
  }, "\n        _Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501.91,
    y: 0,
    width: 47.42,
    height: 42.95,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.772222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 525.62,
    y: 21.475
  }, "\n        _Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 549.33,
    y: 0,
    width: 47.81,
    height: 42.95,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.772222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 573.235,
    y: 21.475
  }, "\n        _Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 597.14,
    y: 0,
    width: 50.41,
    height: 42.95,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.158333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 622.345,
    y: 21.475
  }, "\n        _Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 647.55,
    y: 0,
    width: 52.45,
    height: 42.95,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.579166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 673.775,
    y: 21.475
  }, "\n        _Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.83,
    y: 42.95,
    width: 54.85,
    height: 42.35,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.05
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.254999999999995,
    y: 64.125
  }, "\n        _Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.83,
    y: 85.3,
    width: 54.85,
    height: 43.43,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.343
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.254999999999995,
    y: 107.015
  }, "\n        _Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.83,
    y: 128.73,
    width: 54.85,
    height: 43.56,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.254999999999995,
    y: 150.51
  }, "\n        _Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.83,
    y: 172.29,
    width: 54.85,
    height: 47.72,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.965
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.254999999999995,
    y: 196.14999999999998
  }, "\n        _Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.83,
    y: 220.01,
    width: 54.85,
    height: 48.58,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.0725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.254999999999995,
    y: 244.29999999999998
  }, "\n        _Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.83,
    y: 268.58,
    width: 54.85,
    height: 50.54,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.22
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.254999999999995,
    y: 293.84999999999997
  }, "\n        _Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.83,
    y: 319.12,
    width: 54.85,
    height: 51.87,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9899999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.254999999999995,
    y: 345.055
  }, "\n        _St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.83,
    y: 370.99,
    width: 54.85,
    height: 73.19,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.094444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.254999999999995,
    y: 407.58500000000004
  }, "\n        _Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.83,
    y: 444.18,
    width: 54.85,
    height: 79.31,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.986363636363636
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.254999999999995,
    y: 483.83500000000004
  }, "\n        _Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.83,
    y: 523.49,
    width: 54.85,
    height: 85.36,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.835714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.254999999999995,
    y: 566.17
  }, "\n        _Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.83,
    y: 608.85,
    width: 54.85,
    height: 91.15,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.986363636363636
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.254999999999995,
    y: 654.4250000000001
  }, "\n        _Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.68,
    y: 42.95,
    width: 62.05,
    height: 85.11,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.170833333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 108.70500000000001,
    y: 85.505
  }, "\n        _Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.73,
    y: 42.95,
    width: 71.96,
    height: 85.11,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 175.70999999999998,
    y: 85.505
  }, "\n        _Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.69,
    y: 42.95,
    width: 74.69,
    height: 85.11,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.29888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 249.035,
    y: 85.505
  }, "\n        _Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286.37,
    y: 42.95,
    width: 74.87,
    height: 85.11,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.695714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 323.805,
    y: 85.505
  }, "\n        _Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 361.25,
    y: 42.95,
    width: 75.64,
    height: 85.11,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 399.07,
    y: 85.505
  }, "\n        _Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 436.89,
    y: 42.95,
    width: 80.97,
    height: 85.11,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.996666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 477.375,
    y: 85.505
  }, "\n        _Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 517.86,
    y: 42.95,
    width: 90.4,
    height: 85.11,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.15857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 563.0600000000001,
    y: 85.505
  }, "\n        _Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 608.25,
    y: 42.95,
    width: 91.75,
    height: 85.11,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.63875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 654.125,
    y: 85.505
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.68,
    y: 128.05,
    width: 130.11,
    height: 78.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.228571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 142.735,
    y: 167.35000000000002
  }, "\n        _Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.68,
    y: 206.66,
    width: 130.11,
    height: 106.44,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.826666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 142.735,
    y: 259.88
  }, "\n        _Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.68,
    y: 313.1,
    width: 130.11,
    height: 166.86,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.587142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 142.735,
    y: 396.53000000000003
  }, "\n        _Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.68,
    y: 479.96,
    width: 130.11,
    height: 220.04,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.842500000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 142.735,
    y: 589.98
  }, "\n        _Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.79,
    y: 128.05,
    width: 158.84,
    height: 190.03,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 26.473333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 287.21,
    y: 223.065
  }, "\n        _Bronx\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 366.63,
    y: 128.05,
    width: 161.98,
    height: 190.03,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.2475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 447.62,
    y: 223.065
  }, "\n        _Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 528.61,
    y: 128.05,
    width: 171.39,
    height: 190.03,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 34.278
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 614.3050000000001,
    y: 223.065
  }, "\n        _Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.79,
    y: 318.08,
    width: 219.97,
    height: 166.36,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.795
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 317.775,
    y: 401.26
  }, "\n        New_York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.79,
    y: 484.44,
    width: 219.97,
    height: 215.56,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 30.794285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 317.775,
    y: 592.22
  }, "\n        _Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427.75,
    y: 318.08,
    width: 272.25,
    height: 190.01,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 27.14428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 563.875,
    y: 413.085
  }, "\n        _Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427.75,
    y: 508.09,
    width: 272.25,
    height: 191.91,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 38.382
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 563.875,
    y: 604.045
  }, "\n        Kings\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1972);
export default __webpack_public_path__ + "static/media/1972.0c49f026955032d867b14f6fece635a3.svg";
export { ForwardRef as ReactComponent };